module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/hipotecario/detalles/components/capacidad-pago.component.scss
// module id = ./src/app/creditos/hipotecario/detalles/components/capacidad-pago.component.scss
// module chunks = main